import { useAssistantDraftStore } from '@/modules/assistant/shared/assistant-store';
import type { AssistantDraft } from '@/api/schemas/assistant';

/**
 * The published draft, when it is for THIS form.
 *
 * A draft names the capability it is for, and a form names the capability it
 * accepts. A form that asks for `tenant.create` is given a `tenant.create` draft
 * and nothing else — a `catalog.product` draft published a moment earlier is not
 * something a tenant form may fill itself with.
 *
 * The subscription is a store read, not an effect: the value is derived from the
 * store's current state, so there is nothing to synchronise and nothing that can
 * be set during a render.
 */
export function useAssistantDraftFor(capability: string): AssistantDraft | null {
  const draft = useAssistantDraftStore((state) => state.draft);
  return draft !== null && draft.capability === capability ? draft : null;
}

/** The actions a surface needs to publish or withdraw a draft. */
export function useAssistantDraftActions() {
  const setDraft = useAssistantDraftStore((state) => state.setDraft);
  const clearDraft = useAssistantDraftStore((state) => state.clearDraft);
  return { setDraft, clearDraft };
}
